import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/_services';
import { HasPermissionDirective } from '../../_directives';
declare const $: any;
interface RouteInfo {
	path: string;
	title: string;
	icon: string;
	permission: string;
}
export const ROUTES: RouteInfo[] = [
	{ path: 'dashboard', title: 'Dashboard', icon: 'fa fa-box', permission: 'dashboard.active' },
	{ path: 'alarm', title: 'Alarm', icon: 'fa fa-clock', permission: 'alarm.active' },
	// { path: 'dataRectify', title: 'Data Rectify', icon: '/assets/img/rectify.png', permission: 'dataRectify.active' },
	{
		path: 'maptracker',
		title: 'Maptracker',
		icon: 'fa fa-map',
		permission: 'maptracker.active.active'
	},
	{ path: 'admin', title: 'Admin', icon: 'fa fa-user', permission: 'admin.active' },
	{ path: 'reports', title: 'Reports', icon: 'fa fa-file', permission: 'reports.active' },
	{ path: 'crm', title: 'CRM', icon: 'fa fa-handshake', permission: 'crm.active' },
	{ path: 'superAdmin', title: 'Super Admin', icon: 'fa fa-user-circle', permission: 'superAdmin.active' },
	{
		path: 'maintenance',
		title: 'Maintenance',
		icon: 'fa fa-cog',
		permission: 'maintenance.active'
	},
	{ path: 'mobility', title: 'Mobility', icon: 'fa fa-mobile', permission: 'mobility.active' },
	{ path: 'iSWM', title: 'iSWM', icon: 'fa fa-location-arrow', permission: 'iSWM.active' }
	// { path: 'iec', title: 'I.E.C.',  icon: '/assets/img/iec.png',permission:'iec.active'},
];

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	providers: [ HasPermissionDirective ]
})
export class SidebarComponent implements OnInit {
	menuItems: any[];
	userName: any;
	isSuperadmin: any;

	constructor(private auth: AuthService,) {}

	ngOnInit() {
		this.menuItems = ROUTES.filter((menuItem) => menuItem);

		this.userName = this.auth.getAuthentication().userName;

		if(this.userName.includes('ASI_')){
			if($( window ).width() <= 600){
			  $( ".main-menu" ).hide();
			}
			else{
			  $( ".main-menu" ).show();
			}
		}
	}
	isMobileMenu() {
		if ($(window).width() > 600) {
			return false;
		}
		return true;
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts